import React, { useState, useEffect } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import FiltersPartial from "./FiltersPartial.js";
import Modal from 'react-bootstrap/Modal';
import Multiselect from 'multiselect-react-dropdown';
import { toast } from 'react-toastify';


const Index = (props) => {
  const [filtersModel, setFiltersModel] = useState({})
  const [filterModel, setFilterModel] = useState({});
  const [showDropVehicleModal, setShowDropVehicleModal] = useState(false);
  const defaultHeaderConfig = { disableSort: false };
  const [selectedBooking, setSelectedBooking] = useState(null)
  const [rentalServiceCenters, setRentalServiceCenters] = useState([]);
  const [rentalServiceCentersApi] = getApi('rentalServiceCenters');
  const [dropRentalBikeApi] = getApi('dropRentalBikeApi');
  const [cancelDropRentalBikeApi] = getApi('cancelDropRentalBikeApi');
  const [selectedServiceCenter, setSelectedServiceCenter] = useState(null);

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Bike',
      attr: 'bike_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Service Center',
      attr: 'service_center_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer',
      value: (row) => {
        return <>
          <span>{row.rental_customer?.cus_nomenclature_id}</span><br/>
          <span>{row.rental_customer?.name}</span>
        </>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Continued',
      value: (row) => {
        return row.remaining_continuation_count == 0 ? "False" : `True - ${row.remaining_continuation_count}`
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Lease Offer',
      value: (row) => {
        if (row.lease_offer_name){
          return row.lease_offer_name
        } else{
          return "-"
        }
     
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at'
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        return <>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_offer.name)}>
            <form onSubmit={(e) => performAction(e, row.id)} className='d-flex' >
              <select id="action" defaultValue="select_one" className='form-control form-control-sm font-size-11'>
                <option value="select_one" disabled>Select Action</option>
                {row.can_drop && <option value="drop_vehicle">Drop Vehicle</option>}
                {row.can_cancel && <option value="cancel_drop_request">Cancel Drop Request</option>}
              </select>
              <button
                className="ms-2 mt-1 select-btn font-size-10"
                type='submit'
                // disabled={!row.can_drop && !row.can_cancel}
              >
                Select
              </button>
            </form>
          </UiAction>
        </>
      },
      disableSort: true
    },
  ]

  const fetchServiceCenters = async (rental_booking_id) => {
    try {
      const response = await rentalServiceCentersApi({ fields: 'options', rental_booking_id: rental_booking_id }).unwrap();
      setRentalServiceCenters(response.data.service_centers);
    } catch (error) {
    }
  }

  const performAction = async (e, rental_booking_id) => {
    e.preventDefault();
    switch (e.target.action.value) {
      case 'drop_vehicle':
        setShowDropVehicleModal(true);
        fetchServiceCenters(rental_booking_id);
        setSelectedBooking(rental_booking_id);
        break;
      case 'cancel_drop_request':
        try {
          await cancelDropRentalBikeApi({ id: rental_booking_id }).unwrap();
          // setFiltersModel({});
          toast.success('Drop Request Cancelled Successfully !');
        } catch (err) {
          toast.error('Something Went Wrong !');
        }
        break;
      default:
        toast.error('Select Action To Perform !');
    }
    e.target.action.value = 'select_one'
  }

  const dropVehicle = async (e) => {
    e.preventDefault();
    try {
      await dropRentalBikeApi({ service_center_id: selectedServiceCenter, id: selectedBooking }).unwrap();
      // setFiltersModel({})
      handleModalClose();
      toast.success('Drop Request Generated Successfully !');
    } catch (err) {
      toast.error('Something went wrong !');
    }
  }

  const handleModalClose = () => {
    setShowDropVehicleModal(false);
    setSelectedBooking(false);
  }

  return <>
    <ListingPageComponent
      key={PAGES.RentalBookingsPage.name}
      uiPage={uiManager.getUiPage(PAGES.RentalBookingsPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Rental Bookings List' }]}
      listingMutation={getApi('rental_bookings')}
      className="rental-bookings-listing-page"
      contentHeading="Rental Bookings List - Results"
      headers={headers}
      recordsKey="rental_bookings"
      filtersModel={filterModel}
      filters={
        <FiltersPartial
          filtersModel={filterModel}
          setFiltersModel={setFilterModel}
        />
      }
      searchBy={['ID', 'Customer Id']}
    />
    <Modal
      show={showDropVehicleModal}
      onHide={handleModalClose}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header
        style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
        className="text-white"
        closeButton
      >
        <Modal.Title>Select Service Center</Modal.Title>
      </Modal.Header>
      <form onSubmit={dropVehicle}>
        <Modal.Body>
          <Multiselect
            id='pincode'
            options={rentalServiceCenters}
            emptyRecordMsg={"Select Service Center"}
            singleSelect={true}
            displayValue='name'
            onSelect={(selectedList, selectedItem) => setSelectedServiceCenter(selectedItem.id)}
            onRemove={(selectedList, selectedItem) => setSelectedServiceCenter(null)}
            showArrow={true}
            customArrow={true}
          />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-sm btn-voltup-theme" style={{ width: "max-content" }} onClick={handleModalClose}>
            Close
          </button>
          <button disabled={selectedServiceCenter == null} type='submit' className='btn btn-sm btn-voltup-theme'>
            Submit
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  </>
}

export default Index;
